import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import DesignSystemContext from '../contexts/DesignSystemContext';
import Logo2019 from './assets/Logo2019';
import Logo2020 from './assets/Logo2020';
import Brandmark2019 from './assets/Brandmark2019';
import Brandmark2020 from './assets/Brandmark2020';
import LogoStacked2019 from './assets/LogoStacked2019';
import LogoStacked2020 from './assets/LogoStacked2020';
import LogoBauble2023 from './assets/LogoBauble2023';
import LogoAnimated from './assets/LogoAnimated';
import {
  CREATIVE_ADVENTURES,
  CREATIVE_ADVENTURES_DARK,
  FIND_YOUR_THING,
  FIND_YOUR_THING_DARK,
} from '../themes/ids';

// Brands
const REDBUBBLE = 'redbubble';

// eslint-disable-next-line consistent-return
const Logo = (props?: any) => {
  const { theme } = useContext(DesignSystemContext);
  const {
    brand,
    colored,
    contrast,
    color,
    brandmarkOnly,
    stacked,
    bauble,
    animated,
  } = props;

  let fillColor;
  let wordMarkColor;
  let brandMarkColor;

  if (typeof color === 'string') {
    fillColor = color;
  } else if (typeof color === 'object') {
    wordMarkColor = color.wordMark;
    brandMarkColor = color.brandMark;
  }

  const assetLookup = {
    [FIND_YOUR_THING]: {
      [REDBUBBLE]: {
        default: Logo2019,
        brandmarkOnly: Brandmark2019,
        stacked: LogoStacked2019,
        bauble: LogoBauble2023,
        animated: LogoAnimated,
      },
    },
    [CREATIVE_ADVENTURES]: {
      [REDBUBBLE]: {
        default: Logo2020,
        brandmarkOnly: Brandmark2020,
        stacked: LogoStacked2020,
        bauble: LogoBauble2023,
        // As of writing, the animated logo only fits the theme of the FIND_YOUR_THEME theme.
        // But, the key/value needs to be provided here as well for the headers to render.
        animated: LogoAnimated,
      },
    },
  };

  (assetLookup as any)[FIND_YOUR_THING_DARK] = assetLookup[FIND_YOUR_THING];
  (assetLookup as any)[CREATIVE_ADVENTURES_DARK] = assetLookup[CREATIVE_ADVENTURES];

  let type = 'default';
  if (stacked) type = 'stacked';
  if (brandmarkOnly) type = 'brandmarkOnly';
  if (bauble) type = 'bauble';
  if (animated) type = 'animated';

  const LogoAsset = assetLookup[theme.id][brand][type];

  const colorProps = {
    fillColor,
    wordMarkColor,
    brandMarkColor,
  };
  if (colored && contrast) colorProps.wordMarkColor = 'white';
  if (!colored) colorProps.fillColor = contrast ? 'white' : '#19124F';

  return (
    <LogoAsset {...colorProps} />
  );
};

(Logo as any).displayName = 'Logo';

(Logo as any).propTypes = {
  /**
    * Private: Choose a brand to render the correct Logo, currently only 'redbubble' is available.
    */
  brand: PropTypes.oneOf([
    REDBUBBLE,
  ]),
  /**
    * Renders the Logo in it's default full-color version.
    */
  colored: PropTypes.bool,
  /**
    * Renders the Logo in the contrast version.
    */
  contrast: PropTypes.bool,
  /**
    * Renders the brandmark only without the wordmark (redbubble text).
    */
  brandmarkOnly: PropTypes.bool,
  /**
    * Renders the stacked Logo version (brandmark above wordmark).
    */
  stacked: PropTypes.bool,
  /**
    * Renders the bauble Logo version.
  */
  bauble: PropTypes.bool,
  /**
    * Private: Color gives you the option to change the full color of the Logo
    * or change the color of the brandmark and the wordmark independently.
    */
  color: PropTypes.string,
  /**
   * Renders 2019 redbubble logo with 'surprise' hidden egg animation
   */
  animated: PropTypes.bool,
};

(Logo as any).defaultProps = {
  contrast: false,
  colored: true,
  color: '',
  brand: REDBUBBLE,
  brandmarkOnly: false,
  stacked: false,
  bauble: false,
  animated: false,
};

export default Logo;
